import React from "react";
import SelectMenu from "../../controls/SelectMenu";
import Input from "../../controls/Input";
import DatePickerInput from "../../controls/DatePickerInput";

export default function SunDistributionDetailsSection(props: any) {
  const {
    values,
    errors,
    handleInputChange,
    customers,
    employeeOptions,
    sunCustomers,
  } = props;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <SelectMenu
        handleInputChange={handleInputChange}
        name="customer"
        options={customers}
        value={values.customer}
        title={"Customer *"}
        error={errors.customer}
        showLabel={true}
        parentClass="col-span-2"
      />

      
      <Input
        label="PO # *"
        name="po_number"
        onChange={handleInputChange}
        value={values.po_number}
        labelOn={true}
        type="text"
        error={errors.po_number}
        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
      />

      <Input
        label="Customer PO Number"
        name="sun_customer_po_number"
        onChange={handleInputChange}
        value={values.sun_customer_po_number}
        labelOn={true}
        type="text"
        autoComplete="off"
        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
      />

      <DatePickerInput
        label="Order Date *"
        name="order_date"
        onChange={handleInputChange}
        value={values.order_date}
        labelOn={true}
        minDate={new Date()}
        dateFormat="LLL dd, yyyy"
        type="text"
        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
        error={errors.order_date}
      />

      <DatePickerInput
        label="Expected Date"
        name="expected_date"
        onChange={handleInputChange}
        value={values.expected_date ? values.expected_date : null}
        labelOn={true}
        minDate={new Date()}
        dateFormat="LLL dd, yyyy"
        type="text"
        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
        error={errors.expected_date}
      />

      <Input
        label="BOL Number"
        name="sun_bol_number"
        onChange={handleInputChange}
        value={values.sun_bol_number}
        labelOn={true}
        type="text"
        autoComplete="off"
        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
      />

      <Input
        label="Appointment Number"
        name="appointment_number"
        onChange={handleInputChange}
        value={values.appointment_number}
        labelOn={true}
        type="text"
        autoComplete="off"
        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
      />

      <Input
        label="Temperature Recorder Number"
        name="temperature_recorder_number"
        onChange={handleInputChange}
        value={values.temperature_recorder_number}
        labelOn={true}
        type="text"
        autoComplete="off"
        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
      />

      <Input
        label="Pallet Count"
        name="pallet_count"
        onChange={handleInputChange}
        value={values.pallet_count}
        labelOn={true}
        type="text"
        autoComplete="off"
        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
      />

      <Input
        label="Chep Pallet Count"
        name="chep_pallet_count"
        onChange={handleInputChange}
        value={values.chep_pallet_count}
        labelOn={true}
        type="text"
        autoComplete="off"
        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
      />

      <Input
        label="Total Freight Weight"
        name="total_freight_weight"
        onChange={handleInputChange}
        value={values.total_freight_weight}
        labelOn={true}
        type="text"
        autoComplete="off"
        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
      />

      <Input
        label="Carrier Name"
        name="carrier_name"
        onChange={handleInputChange}
        value={values.carrier_name}
        labelOn={true}
        type="text"
        autoComplete="off"
        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
      />

      <Input
        label="Invoice #"
        name="invoice_number"
        onChange={handleInputChange}
        value={values.invoice_number}
        labelOn={true}
        type="text"
        autoComplete="off"
        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
      />

      <Input
        label="Seal #"
        name="seal_number"
        onChange={handleInputChange}
        value={values.seal_number}
        labelOn={true}
        type="text"
        autoComplete="off"
        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
      />

      <Input
        label="WFP Text"
        name="wfp_text"
        onChange={handleInputChange}
        value={values.wfp_text}
        labelOn={true}
        type="text"
        autoComplete="off"
        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
      />

      <Input
        label="WFP Load ID Number"
        name="wfp_load_id_number"
        onChange={handleInputChange}
        value={values.wfp_load_id_number}
        labelOn={true}
        type="text"
        autoComplete="off"
        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
      />

      <Input
        label="WFP Pickup Date"
        name="wfp_pickup_date"
        onChange={handleInputChange}
        value={values.wfp_pickup_date}
        labelOn={true}
        type="text"
        autoComplete="off"
        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
      />

      <Input
        label="WFP Gate In / Gate Out Times"
        name="wfp_gate_in_gate_out_times"
        onChange={handleInputChange}
        value={values.wfp_gate_in_gate_out_times}
        labelOn={true}
        type="text"
        autoComplete="off"
        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
      />

<SelectMenu
        handleInputChange={handleInputChange}
        name="created_by"
        options={employeeOptions}
        value={values.created_by}
        title={"Employee *"}
        error={errors.created_by}
        showLabel={true}
      />

    </div>
  );
}
